"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const atoms_1 = require("../../atoms");
const clsx_1 = __importDefault(require("clsx"));
const ACTIVE_STYLE = 'text-gray-900 bg-gray-50 hover:bg-white outline-none dark:text-gray-300 dark:bg-gray-800 dark:hover:text-gray-200 dark:hover:bg-gray-700';
const NON_ACTIVE_STYLE = 'hover:text-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300';
function SidebarNavigationItem({ title, subElements, active, children, expanded: propExpanded, icon, href, onClick, renderItem: propRenderItem, }, ref) {
    const renderItem = propRenderItem || ((item, index) => react_1.default.createElement(SidebarNavigationItem, Object.assign({}, item, { key: item.title })));
    const [expanded, setExpanded] = react_1.useState(propExpanded);
    const Icon = icon;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { ref: ref, href: href, onClick: (e) => {
                if (subElements && subElements.length > 0)
                    setExpanded(!expanded);
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }, className: clsx_1.default('group flex items-center p-2 w-full dark:text-gray-400 text-gray-600 text-sm font-medium leading-5 rounded-md transition duration-150 ease-in-out', active ? ACTIVE_STYLE : NON_ACTIVE_STYLE) },
            Icon && react_1.default.createElement(Icon, { className: clsx_1.default('mr-3 w-6 h-6 ') }),
            title,
            children,
            subElements && subElements.length > 0 && (react_1.default.createElement(atoms_1.ExpandIcon, { className: clsx_1.default('ml-auto w-5 h-5 transform transition-colors duration-150 ease-in-out', expanded ? 'rotate-90 text-gray-400 text-gray-400' : 'text-gray-300') }))),
        subElements && subElements.length > 0 && expanded && (react_1.default.createElement("div", { className: `mt-1 space-y-1 pl-4 ${expanded ? '' : 'hidden'}` }, subElements === null || subElements === void 0 ? void 0 : subElements.map((item, index) => renderItem({ ...item, renderItem }, index))))));
}
exports.default = react_1.forwardRef(SidebarNavigationItem);
